<template>
  <transition name="fade">
    <div class="c-saving" v-if="show">
      <base-icon class="mr-2 icon" width="24" height="24" name="painel/cloud" />
      Salvando
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      startedShowOn: null,
    }
  },

  methods: {
    toggleWithDelay() {
      const currentTime = Date.now()

      if (this.show) {
        if (this.startedShowOn && currentTime - this.startedShowOn < 1000) {
          setTimeout(() => {
            this.show = false
            this.$emit('closed')
          }, 1000 - (currentTime - this.startedShowOn))
        } else {
          this.show = false
          this.$emit('closed')
        }
        this.startedShowOn = null
      } else {
        this.show = true
        this.startedShowOn = currentTime
      }
    },
    toggle() {
      this.show = true
      setTimeout(() => {
        this.show = false
        this.$emit('closed')
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-saving {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: normal;
  line-height: 1;
  color: $neutral;

  .icon {
    color: $neutrallight;
  }
}
</style>
